/**
 * These are the only valid modal modes which can be passed into ModalUser
 *
 * @readonly
 * @enum {ModalUserModes}
 */
export const ModalUserModes = {
    CREATE: 'create',
    EDIT: 'edit',
    VIEW: 'view',
    DELETE: 'delete',
    RESET_PASSWORD: 'reset'
}

export const userRecord = ( userData, user_type ) =>
{
    if ( userData === null )
    {
        return {
                username: null,
                firstname: null,
                surname: null,
                address1: null,
                address2: null,
                address3: null,
                address4: null,
                postcode: null,
                telephone: null,
                email: null,
                organisation_name: null,
                school_name: null,
                school_id: null,
                is_organisation: false,
                education_attached: false,
                organisation_type_id: null,
                usertype: user_type,
            }
    }
    else
    {
        const school_name = userData.school !== undefined ? userData.school.school_name : null ;

        return {
            username: userData.username ,
            firstname: userData.firstname,
            surname: userData.surname,
            address1: userData.address1,
            address2: userData.address2,
            address3: userData.address3,
            address4: userData.address4,
            postcode: userData.postcode,
            telephone: userData.telephone,
            email: userData.email,
            organisation_name: userData.organisation_name,
            school_name: school_name,
            school_id: null,
            is_organisation: userData.organisation_type_id !== null,
            education_attached: +(userData.education_attached) === 1,
            organisation_type_id: userData.organisation_type_id === null ? null : { value: +(userData.organisation_type_id)},
            usertype: +(userData.type_id),
        }
    }
}

export const UserFieldNames = {
    EMAIL : 'email',
}